export const API_BASE = "/api/v2";
